<style lang="scss" scoped>
@import "/src/styles/scss/_variables.scss";
@import "./list.scss";
</style>
<template>
  <div class="slk-g-list" :style="`width: ${wrapperWidth};`" @keydown.down="nextItem">
    <div
      class="item"
      v-for="(item, index) in listItems"
      v-bind:key="index"
      :class="`${variant == 'answer' ? 'answer small' : size} ${index == hoverIndex ? 'selected' : ''} ${
        item.selected ? 'selected' : ''
      } ${item.disabled ? 'disabled' : ''}`"
      @click="handleItemClick(item)"
    >
      <div class="control-left" v-if="item.controlLeft">
        <svg class="feather" v-if="item.isIcon">
          <use :href="`/imgs/storybook/feather-sprite.svg#${item.icon}`" />
        </svg>
        <img :src="item.imagePath" alt="" v-if="item.isImage" />
        <Radio :isSelected="false" :disabled="false" v-if="item.isControlRadio" />
        <Checkbox :isChecked="false" :disabled="false" v-if="item.isControlCheckbox" />
      </div>
      <div class="content">
        <div class="label">{{ item.label }}</div>
        <div class="description" v-if="item.hasDescription">{{ item.description }}</div>
        <Indicator
          v-if="item.hasIndicator"
          size="large"
          variant="info"
          indicatorStyle="filled"
          :disabled="false"
          :counter="item.indicatorValue"
        />
      </div>
      <div class="control-right" v-if="item.controlRight">
        <svg class="feather">
          <use :href="`/imgs/storybook/feather-sprite.svg#${item.iconRight}`" />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import Radio from "../radio/radioView.vue";
import Checkbox from "../checkbox/checkboxView.vue";
import Indicator from "../indicator/indicatorView.vue";

const ListItems = [
  {
    label: "",
    description: "",
    hasDescription: true,
    controlLeft: false,
    controlRight: false,
    isControlRadio: false,
    isControlCheckbox: false,
    icon: "star",
    isIcon: false,
    disabled: false,
  },
  {
    label: "",
    description: "",
    hasDescription: true,
    controlLeft: false,
    controlRight: false,
    isControlRadio: false,
    isControlCheckbox: false,
    icon: "star",
    isIcon: false,
    disabled: false,
  },
  {
    label: "",
    description: "",
    hasDescription: true,
    controlLeft: false,
    controlRight: false,
    isControlRadio: false,
    isControlCheckbox: false,
    icon: "star",
    isIcon: false,
    disabled: false,
  },
  {
    label: "",
    description: "",
    hasDescription: true,
    controlLeft: false,
    controlRight: false,
    isControlRadio: false,
    isControlCheckbox: false,
    icon: "star",
    isIcon: false,
    disabled: false,
  },
  {
    label: "",
    description: "",
    hasDescription: true,
    controlLeft: false,
    controlRight: false,
    isControlRadio: false,
    isControlCheckbox: false,
    icon: "star",
    isIcon: false,
    disabled: false,
  },
  {
    label: "",
    description: "",
    hasDescription: true,
    controlLeft: false,
    controlRight: false,
    isControlRadio: false,
    isControlCheckbox: false,
    icon: "star",
    isIcon: false,
    disabled: false,
  },
  {
    label: "",
    description: "",
    hasDescription: true,
    controlLeft: false,
    controlRight: false,
    isControlRadio: false,
    isControlCheckbox: false,
    icon: "star",
    isIcon: false,
    disabled: false,
  },
  {
    label: "",
    description: "",
    hasDescription: true,
    controlLeft: false,
    controlRight: false,
    isControlRadio: false,
    isControlCheckbox: false,
    icon: "star",
    isIcon: false,
    disabled: false,
  },
  {
    label: "Invitations",
    description: "",
    hasDescription: false,
    controlLeft: true,
    controlRight: false,
    isControlRadio: false,
    isControlCheckbox: false,
    icon: "inbox",
    isIcon: true,
    disabled: false,
    hasIndicator: true,
    indicatorValue: "9+",
  },
  {
    label: "Language",
    description: "",
    hasDescription: false,
    controlLeft: true,
    controlRight: true,
    isControlRadio: false,
    isControlCheckbox: false,
    icon: "globe",
    isIcon: true,
    iconRight: "arrow-right",
    disabled: false,
  },
];

export default {
  name: "list-view",
  props: {
    variant: { type: String, default: "dropdown" },
    size: { type: String, default: "medium" },
    listItems: { type: Array },
    wrapperWidth: { type: String },
  },
  components: {
    Radio,
    Checkbox,
    Indicator,
  },
  methods: {
    handleItemClick(clickedItem) {
      this.$emit("item-clicked", clickedItem);
    },
    nextItem() {
      this.hoverIndex =
        this.hoverIndex == null ? 0 : this.hoverIndex + 1 > this.listItems.length - 1 ? 0 : ++this.hoverIndex;
    },
    previousItem() {
      this.hoverIndex =
        this.hoverIndex == null ? 0 : this.hoverIndex - 1 < 0 ? this.listItems.length - 1 : --this.hoverIndex;
    },
    selectItem() {
      this.$emit("item-clicked", this.listItems[this.hoverIndex]);
    },
  },
  data() {
    return {
      clickedItemLabel: "",
      hoverIndex: null,
    };
  },
};
</script>
